/**
 * @fileoverview หน้า "Series" (ซีรีส์)
 *
 * ชื่อบนหน้าจอ = Series / ซีรีส์ (ฟิลด์: รหัสซีรีส์, ชื่อซีรีส์, คำอธิบาย, สถานะ)
 * ข้อมูลจริง   = table `series` (API: warehouse/series, permission: serie.*) — master อิสระ (ชั้น "แบรนด์หลัก" ถูกยกเลิกแล้ว)
 * อ้างอิงจาก   = part_masters.serie_id, part_compatible_series.serie_id (ฟอร์มขึ้นทะเบียนเครื่องจักรใช้ master ยี่ห้อ/รุ่น ไม่ใช้ซีรีส์)
 *
 * กฎการบันทึก: รหัส/ชื่อ trim + ตัวพิมพ์ใหญ่ก่อนส่ง, รหัสซ้ำ -> "รหัสซีรีส์นี้มีอยู่แล้ว"
 * ข้อมูลเก่าที่ยังไม่มีรหัส แสดง "-" และต้องกรอกให้ครบเมื่อกดแก้ไข
 *
 * ชื่อ field/API/permission ยังใช้คำว่า serie/series ตามเดิมโดยตั้งใจ (ดู glossary ใน components/global.js)
 */

import React, { Component } from "react";
import {
  company,
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  Select,
  ActionIconButton,
  ACTION_ICONS,
  fmtInt
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission";

// ตัดช่องว่างหน้า-หลัง + ตัวพิมพ์ใหญ่ (ใช้กับรหัสแบรนด์และชื่อแบรนด์ก่อนส่ง API)
const normalizeText = (value) => String(value ?? "").trim().toUpperCase();

// แปลงข้อความ error จาก backend ("This Brand Code already exists") เป็นข้อความที่ผู้ใช้เข้าใจ
const brandErrorMessage = (message) => {
  const msg = String(message || "");
  if (/already exists/i.test(msg)) {
    if (/code/i.test(msg)) return t("brand_code_exists");
    if (/name/i.test(msg)) return t("brand_name_exists");
  }
  return msg || t("error_occurred");
};

export default class SeriesManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_status: "",

      modal_create: false,
      modal_update: false,
      count: 0,

      // Form States (Modal)
      uid: "",
      company_id: company?.id || "", // Default company_id
      serie_code: "",
      name: "",
      description: "",
      is_active: "Active",

      // List Data
      data: [],
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search } = this.state;
    let data, count;
    loading(true);

    // Call GET API Series
    let result = await GET("warehouse/series", { 
        page_size: 10, 
        page: page, 
        data_search: filter_search || "",
        is_active: this.state.filter_status || "",
    });

    if (result?.status) {
      data = result.data;
      count = result.pagination?.count || 0;
    }

    this.setState({ data: data || [], count });
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_id,
      serie_code,
      name,
      description,
      is_active,
    } = this.state;

    // Validation: รหัส / ชื่อ บังคับ -> trim + ตัวพิมพ์ใหญ่ก่อนส่ง
    const normalized_code = normalizeText(serie_code);
    const normalized_name = normalizeText(name);
    if (!normalized_code) {
      alert("", "warning", t("warning"), t("verify_brand_code"));
      return;
    } else if (!normalized_name) {
      alert("", "warning", t("warning"), t("verify_brand_name"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      
      // Request Body
      let body = {
        company_id,
        serie_code: normalized_code,
        name: normalized_name,
        description: (description || "").trim(),
        is_active: is_active === "Active",
      };

      // Call API
      let result = !uid
        ? await POST("warehouse/series", body)
        : await PUT("warehouse/series/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false }, () => {
            this.Get(1); // Refresh data
        });
      } else {
        alert("", "warning", t("warning"), brandErrorMessage(result?.message));
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/series/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1); // Refresh data after delete
      }
      loading(false);
    }
  };

  resetForm = () => {
    this.setState({
      uid: "",
      serie_code: "",
      name: "",
      description: "",
      is_active: "Active",
    });
  };

  render() {
    const {
      data,
      count,
      filter_search,
      filter_status,
      modal_create,
      modal_update,
      serie_code,
      name,
      description,
      is_active,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("brand_management")}</h3>
                        <div className="text-secondary text-14">{t("manage_brands_desc")}</div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex gap-2 flex-wrap">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_brands")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                />
                            </div>
                            <Select
                                className="form-control wpx-150"
                                options={[
                                    { value: "true", label: t("active") },
                                    { value: "false", label: t("inactive") },
                                ]}
                                value={filter_status}
                                onChange={(e) => this.setState({ filter_status: e })}
                                placeholder={t("all_status")}
                                defaultLabel={t("all_status")}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", filter_status: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        {can("serie.create") && (
                        <button
                            className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                            onClick={() => {
                                this.resetForm();
                                this.setState({ modal_create: true });
                            }}
                        >
                            <span className="me-2 text-16">+</span> {t("add_brand")}
                        </button>)}
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                    {/* Series Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 border-0 wpx-250">{t("brand")}</th>
                                    <th className="py-3 border-0 wpx-250">{t("description")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        {/* Series Info */}
                                        <td className="py-3">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-primary`}
                                                >
                                                    <span className="icon">{"\uf02b"}</span>
                                                </div>
                                                <div>
                                                    <div className="fw-bold text-dark text-14">{item.name}</div>
                                                    <div className="text-secondary text-10">
                                                        {t("code")}: {item.serie_code || "-"}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Description */}
                                        <td>
                                            <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "250px" }}>
                                                {item.description || "-"}
                                            </div>
                                        </td>

                                        {/* Status */}
                                        <td className="text-center">
                                            {item.is_active ? (
                                                <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                            ) : (
                                                <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                            )}
                                        </td>

                                        {/* Actions */}
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-2 justify-content-center">
                                                                                                <ActionIconButton
                                                    label={can("serie.update") ? t("edit") : t("view")}
                                                    icon={can("serie.update") ? ACTION_ICONS.edit : ACTION_ICONS.view}
                                                    variant={can("serie.update") ? "warning" : "primary"}
                                                    onClick={() => {
                                                        this.setState({
                                                            modal_update: true,
                                                            uid: item.uid,
                                                            serie_code: item.serie_code || "",
                                                            name: item.name || "",
                                                            description: item.description || "",
                                                            is_active: item.is_active ? "Active" : "Inactive",
                                                        });
                                                    }}
                                                />
                                                {can("serie.delete") && (
                                                <ActionIconButton
                                                    label={t("delete")}
                                                    icon={ACTION_ICONS.delete}
                                                    variant="danger"
                                                    onClick={() => {
                                                        this.Delete(item.uid);
                                                    }}
                                                />)}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} {data.length > 0 ? 1 : 0}-{data.length} {t("of")} {fmtInt(count)} {t("brands_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                </div>
            </div>

            {/* MODAL: ADD/EDIT SERIES */}
            <Modal
                size="md"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit_brand") : t("add_new_brand")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
<fieldset disabled={(this.state.modal_update && !can("serie.update"))} className="border-0 p-0 m-0" style={(this.state.modal_update && !can("serie.update")) ? { pointerEvents: "none" } : undefined}>
                    <div className="row g-4">
                        {/* Basic Information */}
                        <div className="col-12">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf05a"}</span> {t("basic_information")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("brand_basic_info_desc")}</small>
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("brand_code")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={50}
                                        className="form-control py-2 text-uppercase"
                                        placeholder="e.g. TSURUMI"
                                        value={serie_code}
                                        onChange={(e) => this.setState({ serie_code: e.target.value })}
                                        onBlur={() => this.setState({ serie_code: normalizeText(serie_code) })}
                                    />
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("brand_name")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={200}
                                        className="form-control py-2 text-uppercase"
                                        placeholder="e.g. TSURUMI PUMP"
                                        value={name}
                                        onChange={(e) => this.setState({ name: e.target.value })}
                                        onBlur={() => this.setState({ name: normalizeText(name) })}
                                    />
                                    <small className="text-muted d-block mt-1">{t("brand_uppercase_hint")}</small>
                                </div>
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("description")}</label>
                                    <textarea
                                        className="form-control py-2"
                                        rows="3"
                                        placeholder={t("brand_description")}
                                        value={description}
                                        onChange={(e) => this.setState({ description: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-2 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                            </h6>
                            <div className="d-flex gap-4 mt-3">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="seriesStatus"
                                        id="statusActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="seriesStatus"
                                        id="statusInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
</Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
{!(this.state.modal_update && !can("serie.update")) && (
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={() => {
                            this.CreateUpdate();
                        }}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>)}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}